import React, { useEffect, useState } from 'react'

export default function AroundCircle({ dataArray = [], title, radius = 200, reload }) {
    const [degsArray, setDegsArray] = useState([]);
    const createDegsArray = () => {
        let array = [];
        let progress = 360 / dataArray.length;
        let last = 0;
        for (let index = 0; index < dataArray.length; index++) {
            array.push(last + progress);
            last = last + progress
        }
        setDegsArray(array);
    }
    useEffect(() => {
        createDegsArray();

    }, [dataArray, reload])
    const circleJSX = dataArray.map(function (single, index) {
        return (
            <div
                className="text-[13px] text-white p-3 text-center font-black absolute w-[100px] h-[100px] bg-[#387ADF] rounded-full flex justify-center items-center"
                style={{ right: `${Math.round(Math.sin(degsArray[index] * Math.PI / 180) * radius) + radius}px`, top: `${Math.round(Math.cos(degsArray[index] * Math.PI / 180) * radius) + radius}px` }}
            >
                {single}
            </div>
        )
    })
    return (
        <div className='flex w-full justify-center items-center'>
            <div className='relative flex justify-center items-center' style={{ width: `${radius * 2}px`, height: `${radius * 2}px` }}>
                <div className='top-0 left-0 absolute w-[550px] h-[550px] bg-[#D1E9F6] z-[-1] rounded-full' style={{ left: `-${radius / 1.6}px`, top: `-${radius / 10}px` }}></div>
                {circleJSX}
                <div
                    className='font-bold text-lg text-center p-3 text-black flex justify-center items-center bg-[#F6EACB] rounded-full'
                    style={{ marginTop: `${radius / 2}px`, marginRight: `${radius / 2}px`, width: `${radius * 1.3}px`, height: `${radius * 1.3}px` }}
                >
                    {title}
                </div>
            </div>
        </div>
    )
}
